var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickHeart = function SvgTickHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.224 2.74A9.5 9.5 0 0 0 30.151.713a9.58 9.58 0 0 0-7.252 0 9.5 9.5 0 0 0-3.074 2.029L18 4.543l-1.826-1.802A9.54 9.54 0 0 0 9.474 0a9.54 9.54 0 0 0-6.699 2.74A9.3 9.3 0 0 0 0 9.355c0 2.48.998 4.86 2.775 6.614l1.826 1.803L18 31l13.398-13.228 1.826-1.803a9.3 9.3 0 0 0 2.055-3.034 9.25 9.25 0 0 0 0-7.16 9.35 9.35 0 0 0-2.055-3.034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.544 10.129a2 2 0 0 1 2.912 2.742l-9.347 9.93-6.955-6.322a2 2 0 0 1 2.691-2.959l4.045 3.677z"
  })));
};
export default SvgTickHeart;